// Local storage keys
export const LocalStorageKeys = {
  cms_user: 'cms-user',
  access_token: 'access-token',
  refresh_token: 'refresh-token',
  language: 'language',
  expiredTime: '_expiredTime',
  country: 'country',
};
